import * as THREE from 'three';
import { groundDecal, groundUi } from '../environment/ground-decal.js';
import { mergeGeometries } from 'three/addons/utils/BufferGeometryUtils.js';
import { gaugeEdges, makeHealthGauge } from './health-gauge.js';

/** A continuous circle whose four cut-away arcs are replaced by deep inward chevrons. It stands in for the hero's ground circle, so it is its health gauge too. */
export function createSelectionGlyph(radius: number, color: number) {
  const rim = radius * 1.24, tip = radius * .7, stroke = 2 * Math.max(.05, radius * .075);
  const halfAngle = Math.asin(.32 / 1.24), arcSteps = 16;
  function contour(edge: number, point: number) {
    const points: THREE.Vector2[] = [];
    const polar = (angle: number, distance: number) => points.push(new THREE.Vector2(Math.cos(angle) * distance, Math.sin(angle) * distance));
    for (let i = 0; i < 4; i++) {
      const angle = i * Math.PI / 2;
      polar(angle - halfAngle, edge); polar(angle, point); polar(angle + halfAngle, edge);
      // Only the arc between chevrons remains: nothing spans across a V's mouth.
      for (let j = 1; j < arcSteps; j++) polar(angle + halfAngle + (Math.PI / 2 - halfAngle * 2) * j / arcSteps, edge);
    }
    return points;
  }
  const band = (outer: number, outerTip: number, inner: number, innerTip: number, edge: 0 | 1) => {
    const shape = new THREE.Shape(contour(outer, outerTip));
    shape.holes.push(new THREE.Path(contour(inner, innerTip).reverse()));
    return gaugeEdges(new THREE.ShapeGeometry(shape), edge);
  };
  // The body, and the thin edges along its outside and inside that the gauge draws in its edge colour.
  const edge = stroke * .28;
  const geometry = mergeGeometries([band(rim, tip + stroke, rim - stroke, tip, 0), band(rim + edge, tip + stroke + edge, rim, tip + stroke, 1), band(rim - stroke, tip, rim - stroke - edge, tip - edge, 1)])!;
  const glyph = groundUi(groundDecal(new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({ color, side: THREE.DoubleSide, opacity: .95, toneMapped: false }))));
  makeHealthGauge(glyph.material);
  glyph.name = 'selected-hero-glyph'; glyph.rotation.x = -Math.PI / 2; glyph.position.y = .055; glyph.visible = false;
  return glyph;
}
